import { withStateHandlers } from 'recompose';

import { PhoneNumberInput as PhoneInput } from './PhoneNumberInput';

export const PhoneNumberInput = withStateHandlers(
  ({ focused = false }) => ({ focused }),
  {
    // eslint-disable-next-line no-unused-vars
    onFocus: (_, props) => e => {
      props.onFocus && props.onFocus(e);

      return { focused: true };
    },
    // eslint-disable-next-line no-unused-vars
    onBlur: (_, props) => e => {
      props.onFocus && props.onBlur(e);

      return { focused: false };
    },
  },
)(PhoneInput);
